import React from "react";

import { FormattedMessage, useIntl } from "gatsby-plugin-react-intl";
import PropTypes from "prop-types";

import { ReactComponent as IconPasswordReset18 } from "../../../icons/icon/18/a-icon-passwordreset-18.svg";
import { ReactComponent as IconFurther24 } from "../../../icons/icon/24/a-icon-further-24.svg";
import { ReactComponent as IconPasswordReset24 } from "../../../icons/icon/24/a-icon-passwordreset-24.svg";
import AdaptiveIcon from "../../adaptiveIcon/adaptiveIcon";
import IconButton from "../../button/iconButton";
import RegistrationDialogHeadline from "../registrationDialogHeadline";

const RegistrationDialogStepSignUpError = ({ modalLeaveUrl, error }) => {
  const intl = useIntl();

  return (
    <div className="registration-dialog__sign-up-error">
      <div className="registration-dialog__steps"><FormattedMessage id="registration.notice" /></div>
      <RegistrationDialogHeadline
        headline={intl.formatMessage({ id: "error_signup.headline" })}
        subheadline={intl.formatMessage({ id: `error_signup_${error}` })}
      />
      <div className="registration-dialog__sign-up-error__actions">
        <IconButton href={modalLeaveUrl}>
          <FormattedMessage id="registration.complete" /><IconFurther24 />
        </IconButton>

        {(error === "003" || error === "005") && (
          <IconButton href={process.env.GATSBY_SSP_FORGOT_PASSWORD_LINK} variant="inverted-primary" target="_blank">
            <FormattedMessage id="signup.reset_password" />
            <AdaptiveIcon lg={<IconPasswordReset24 />} sm={<IconPasswordReset18 />} />
          </IconButton>
        )}
      </div>
    </div>
  );
};

RegistrationDialogStepSignUpError.propTypes = {
  error: PropTypes.string.isRequired,
  modalLeaveUrl: PropTypes.string.isRequired,
};

export default RegistrationDialogStepSignUpError;
